import React from "react";
import { createPortal } from "react-dom";

const UnarchiveProjectModal = ({ isOpen, onClose, onConfirm, loading, error }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-[8px] shadow-xl w-[550px] px-8 py-5 relative flex flex-col items-center text-center animate-fadeIn">
        <h2 className="text-[#18181B] font-outfit text-[22px] font-semibold mb-3">
          Unarchive this project?
        </h2>

        <p className="text-[#71717A] font-outfit text-[16px] font-normal leading-6 mb-4 max-w-[500px]">
          This will restore the project to My Projects (or Shared With Me for
          collaborators) and clear the archive reason.
        </p>

        {error && (
          <p className="text-[#E21919] font-outfit text-[14px] mb-3">{error}</p>
        )}

        <div className="flex items-center gap-4 w-full justify-center">
          <button
            onClick={onClose}
            disabled={loading}
            className="w-[140px] h-[44px] rounded-[8px] border border-[#E4E4E7] text-[#52525B] font-outfit text-[16px] font-medium hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            className="w-[160px] h-[44px] rounded-[8px] font-outfit text-[16px] font-medium transition-colors flex items-center justify-center bg-[#C95EBE] text-white hover:bg-[#a850a1] disabled:opacity-80 disabled:cursor-not-allowed"
          >
            {loading ? "Unarchiving..." : "Unarchive Project"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnarchiveProjectModal;
